// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function payment_data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var amount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "amount"), null));
  if (amount.TAG === /* Ok */0) {
    var status = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
    if (status.TAG === /* Ok */0) {
      var lead_id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "lead_id"), null));
      if (lead_id.TAG === /* Ok */0) {
        var transaction_id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "transactionId"), null));
        if (transaction_id.TAG === /* Ok */0) {
          var created_at = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "created_at"), null));
          if (created_at.TAG === /* Ok */0) {
            var updated_at = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updated_at"), null));
            if (updated_at.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        amount: amount._0,
                        status: status._0,
                        lead_id: lead_id._0,
                        transaction_id: transaction_id._0,
                        created_at: created_at._0,
                        updated_at: updated_at._0
                      }
                    };
            }
            var e = updated_at._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".updated_at" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = created_at._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".created_at" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = transaction_id._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".transactionId" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = lead_id._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".lead_id" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = status._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".status" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = amount._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".amount" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var payment_history = Decco.listFromJson(payment_data_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "payment_history"), null));
  if (payment_history.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              payment_history: payment_history._0
            }
          };
  }
  var e = payment_history._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".payment_history" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  payment_data_decode ,
  t_decode ,
  
}
/* No side effect */
